/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Player_JerseyInputs */

const th_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.n}`)
};

const en_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.n}`)
};

const ja_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.n}`)
};

const zh_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 号`)
};

const es_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`n.º ${i?.n}`)
};

const pt_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`nº ${i?.n}`)
};

const id_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No. ${i?.n}`)
};

const fr_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`n° ${i?.n}`)
};

const tl_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Blg. ${i?.n}`)
};

const vi_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số ${i?.n}`)
};

const ko_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}번`)
};

const de_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nr. ${i?.n}`)
};

const ru_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`№ ${i?.n}`)
};

const tr_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} numara`)
};

const it_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`N. ${i?.n}`)
};

const pl_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nr ${i?.n}`)
};

const uk_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`№ ${i?.n}`)
};

const hi_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`नं. ${i?.n}`)
};

const ar_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`رقم ${i?.n}`)
};

const ms_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No. ${i?.n}`)
};

const bn_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`নং ${i?.n}`)
};

const zh_tw2_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 號`)
};

const zh_hk2_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 號`)
};

const ur_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`نمبر ${i?.n}`)
};

const fa_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`شمارهٔ ${i?.n}`)
};

const sw_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na. ${i?.n}`)
};

const nl_player_jersey = /** @type {(inputs: Player_JerseyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nr. ${i?.n}`)
};

/**
* | output |
* | --- |
* | "#{n}" |
*
* @param {Player_JerseyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_jersey = /** @type {((inputs: Player_JerseyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_JerseyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_jersey(inputs)
	if (locale === "ja") return ja_player_jersey(inputs)
	if (locale === "zh") return zh_player_jersey(inputs)
	if (locale === "es") return es_player_jersey(inputs)
	if (locale === "pt") return pt_player_jersey(inputs)
	if (locale === "id") return id_player_jersey(inputs)
	if (locale === "fr") return fr_player_jersey(inputs)
	if (locale === "tl") return tl_player_jersey(inputs)
	if (locale === "vi") return vi_player_jersey(inputs)
	if (locale === "ko") return ko_player_jersey(inputs)
	if (locale === "de") return de_player_jersey(inputs)
	if (locale === "ru") return ru_player_jersey(inputs)
	if (locale === "tr") return tr_player_jersey(inputs)
	if (locale === "it") return it_player_jersey(inputs)
	if (locale === "pl") return pl_player_jersey(inputs)
	if (locale === "uk") return uk_player_jersey(inputs)
	if (locale === "hi") return hi_player_jersey(inputs)
	if (locale === "ar") return ar_player_jersey(inputs)
	if (locale === "ms") return ms_player_jersey(inputs)
	if (locale === "bn") return bn_player_jersey(inputs)
	if (locale === "zh-TW") return zh_tw2_player_jersey(inputs)
	if (locale === "zh-HK") return zh_hk2_player_jersey(inputs)
	if (locale === "ur") return ur_player_jersey(inputs)
	if (locale === "fa") return fa_player_jersey(inputs)
	if (locale === "sw") return sw_player_jersey(inputs)
	if (locale === "nl") return nl_player_jersey(inputs)
	return en_player_jersey(inputs)
});